module.exports = __webpack_public_path__ + "img/tablePreview.d0e45d9.png";